import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, map, mergeMap, of } from 'rxjs';
import {
    ApprovePayrollReportSummary,
    LoadAllPayrollReportSummaries,
    LoadAllPayrollReportSummariesFailure,
    LoadAllPayrollReportSummariesSuccess,
    PayrollReportSummaryActionFailure,
    PayrollReportSummaryActionSuccess,
    RejectPayrollReportSummary,
    AddPayrollReportSummaryNote,
    RemovePayrollReportSummaryNote
} from '../actions/payroll-report-summary.actions';
import { PayrollReportManagementControllerService } from '@iota/inh-core-v1-management-client';

@Injectable()
export class PayrollReportSummaryEffects {
    loadAllPayrollReportSummaries$ = createEffect(() =>
        this.actions$.pipe(
            ofType(LoadAllPayrollReportSummaries),
            mergeMap(() =>
                this.apiService.getAllPayrollReportSummaries().pipe(
                    map((payrollReports) => LoadAllPayrollReportSummariesSuccess({ payrollReports })),
                    catchError((error) => of(LoadAllPayrollReportSummariesFailure({ error })))
                )
            )
        )
    );

    approvePayrollReportSummary$ = createEffect(() =>
        this.actions$.pipe(
            ofType(ApprovePayrollReportSummary),
            mergeMap(({ payrollReportSummaryId }) =>
                this.apiService.approvePayrollReport(payrollReportSummaryId).pipe(
                    map((payrollReport) => PayrollReportSummaryActionSuccess({ payrollReport })),
                    catchError((error) => of(PayrollReportSummaryActionFailure({ payrollReportSummaryId, error })))
                )
            )
        )
    );

    rejectPayrollReportSummary$ = createEffect(() =>
        this.actions$.pipe(
            ofType(RejectPayrollReportSummary),
            mergeMap(({ payrollReportSummaryId }) =>
                this.apiService.rejectPayrollReport(payrollReportSummaryId).pipe(
                    map((payrollReport) => PayrollReportSummaryActionSuccess({ payrollReport })),
                    catchError((error) => of(PayrollReportSummaryActionFailure({ payrollReportSummaryId, error })))
                )
            )
        )
    );

    addPayrollReportNote$ = createEffect(() =>
        this.actions$.pipe(
            ofType(AddPayrollReportSummaryNote),
            mergeMap(({ payrollReportSummaryId, note }) =>
                this.apiService.addPayrollReportNote(payrollReportSummaryId, note).pipe(
                    map((payrollReport) => PayrollReportSummaryActionSuccess({ payrollReport })),
                    catchError((error) => of(PayrollReportSummaryActionFailure({ payrollReportSummaryId, error })))
                )
            )
        )
    );

    removePayrollReportSummaryNote$ = createEffect(() =>
        this.actions$.pipe(
            ofType(RemovePayrollReportSummaryNote),
            mergeMap(({ payrollReportSummaryId, noteId }) =>
                this.apiService.deletePayrollReportNote(payrollReportSummaryId, noteId).pipe(
                    map((payrollReport) => PayrollReportSummaryActionSuccess({ payrollReport })),
                    catchError((error) => of(PayrollReportSummaryActionFailure({ payrollReportSummaryId, error })))
                )
            )
        )
    );

    constructor(
        private actions$: Actions,
        private apiService: PayrollReportManagementControllerService
    ) {}
}
